/* Listování díly na celou obrazovku (2026-09-18 na přání majitelky).

   Na telefonu se listuje prstem, na počítači šipkami po stranách nebo
   klávesnicí. Nákup se uvnitř neřeší — stačí, že je pořád na dosah: dole
   je pevná lišta s názvem, cenou a tlačítkem na stránku díla, kde už je
   hotový konfigurátor.

   OKAMŽITÁ ODEZVA (2026-09-19): překryv se otevře hned po klepnutí a ukáže
   obraz, na který návštěvník sáhl — ten už má prohlížeč stažený z dlaždice.
   Teprve potom se doplní zbytek kolekce. Bez toho se čekalo, než server
   poskládá seznam děl, a u velké kolekce to bylo naměřeno 4–6 sekund, během
   kterých se po klepnutí nedělo vůbec nic.

   Seznam děl se stahuje z templates/collection.listovani.liquid, a to už
   ve chvíli, kdy návštěvník na mřížku sáhne. Kdo nesáhne, nestahuje nic.

   Načítá se na stránkách kolekcí a na úvodní stránce (viz layout/theme.liquid).

   OBLÍBENÁ (2026-09-19): dole je vedle nákupu srdce. Ukládá do prohlížeče
   návštěvníka, ne do účtu; samotné ukládání drží assets/oblibene-sklad.js,
   protože tutéž logiku potřebuje i výpis oblíbených a srdíčka v mřížce.

   PŘÍBĚH: pod názvem stojí text z metapole `dilo.pribeh`. Dorazí až se
   seznamem, ne hned při otevření — viz poznámka u pribehEl. */
(function () {
  'use strict';

  // `.product-grid` je výpis kolekce; `[data-listovani]` je mřížka, která si
  // sama řekne, ze které kolekce se má listovat (úvodní stránka).
  var mrizka = document.querySelector('[data-listovani], .product-grid');
  if (!mrizka || !window.fetch || !window.URL) return;

  // Popisky jsou na stránce od začátku (snippets/listovani-texty.liquid),
  // protože překryv se otevírá dřív, než dorazí seznam. Ze seznamu se berou
  // jen jako záloha.
  var texty = {
    zavrit: mrizka.getAttribute('data-listovani-zavrit') || 'Zavřít',
    dalsi: mrizka.getAttribute('data-listovani-dalsi') || 'Další',
    predchozi: mrizka.getAttribute('data-listovani-predchozi') || 'Předchozí',
    koupit: mrizka.getAttribute('data-listovani-koupit') || 'Vybrat variantu',
    oblibene: mrizka.getAttribute('data-listovani-oblibene') || 'Přidat do oblíbených',
    oblibeneZrus: mrizka.getAttribute('data-listovani-oblibene-zrus') || 'Odebrat z oblíbených',
    vic: mrizka.getAttribute('data-listovani-vic') || 'Celý příběh',
    min: mrizka.getAttribute('data-listovani-min') || 'Zabalit'
  };

  var dila = null;
  var slib = null;
  var vrstva = null;
  var stopa = null;
  var pocitadlo = null;
  var nazevEl = null;
  var cenaEl = null;
  var koupitEl = null;
  var srdceEl = null;
  var pribehEl = null;
  var vicEl = null;
  var sipkaZpet = null;
  var sipkaVpred = null;

  var seznam = [];
  var aktualni = -1;
  var otevreno = false;
  var vratitFokus = null;
  var otevrenyHandle = null;
  var SIRKY = [600, 900, 1200, 1600];

  /* ------------------------------------------------------------------ data */

  function adresaSeznamu() {
    // Mřížka může určit vlastní kolekci; jinak se listuje ta, na které stojíme.
    var zaklad = mrizka.getAttribute('data-listovani') || window.location.href;
    var u = new URL(zaklad, window.location.href);
    u.searchParams.set('view', 'listovani');
    // Seznam je vždy celý, ne jen stránka, na které návštěvník stojí.
    u.searchParams.delete('page');
    return u.toString();
  }

  function nacti() {
    if (slib) return slib;
    slib = fetch(adresaSeznamu(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        dila = d && d.dila && d.dila.length ? d.dila : null;
        if (d && d.texty) {
          for (var k in d.texty) { if (!mrizka.getAttribute('data-listovani-' + k)) texty[k] = d.texty[k]; }
        }
        if (!dila) throw new Error('prazdny seznam');
        return dila;
      });
    return slib;
  }

  // Stahovat se začne, jakmile návštěvník sáhne na mřížku.
  mrizka.addEventListener('pointerdown', function () {
    nacti().catch(function () {});
  }, { once: true, passive: true });

  /* ------------------------------------------------- údaje z dlaždice */

  function handleZUrl(u) {
    return String(u || '').split('?')[0].replace(/\/+$/, '').split('/').pop();
  }

  // Z dlaždice v mřížce se dá složit plnohodnotný snímek okamžitě: název,
  // cena i obrázek už na stránce jsou.
  function zDlazdice(odkaz) {
    var karta = odkaz.closest('.art-card, .product-card') || odkaz;
    var img = karta.querySelector('img');
    var nadpis = karta.querySelector('h3');
    var cena = karta.querySelector('.art-price') || karta.querySelector('p');
    return {
      handle: handleZUrl(odkaz.getAttribute('href')),
      nazev: nadpis ? nadpis.textContent.trim() : '',
      cena: cena ? cena.textContent.trim() : '',
      url: odkaz.getAttribute('href'),
      hotovy: img ? (img.currentSrc || img.getAttribute('src')) : ''
    };
  }

  function poradi(pole, handle) {
    for (var i = 0; i < pole.length; i++) {
      if (pole[i].handle === handle) return i;
    }
    return 0;
  }

  /* ----------------------------------------------------------------- vrstva */

  function srcset(url) {
    var oddelovac = url.indexOf('?') === -1 ? '?' : '&';
    return SIRKY.map(function (w) {
      return url + oddelovac + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  // Adresa z dlaždice nese malou šířku (mřížka ji tak potřebuje). Na celou
  // obrazovku se hodí větší; prohlížeč ji vymění, jakmile dorazí.
  function zvetsi(url) {
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=1200');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
  }

  function sipka(smer, znak, popisek, krok) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'listovani-sipka listovani-sipka--' + smer;
    b.innerHTML = znak;
    b.setAttribute('aria-label', popisek);
    b.addEventListener('click', function () { jdiNa(aktualni + krok, true); });
    return b;
  }

  function vytvorVrstvu() {
    vrstva = document.createElement('div');
    vrstva.className = 'listovani';
    vrstva.setAttribute('role', 'dialog');
    vrstva.setAttribute('aria-modal', 'true');
    vrstva.hidden = true;

    var hlava = document.createElement('div');
    hlava.className = 'listovani-hlava';
    pocitadlo = document.createElement('span');
    pocitadlo.className = 'listovani-pocitadlo';
    pocitadlo.setAttribute('aria-live', 'polite');
    var zavrit = document.createElement('button');
    zavrit.type = 'button';
    zavrit.className = 'listovani-zavrit';
    zavrit.innerHTML = '&times;';
    zavrit.setAttribute('aria-label', texty.zavrit);
    zavrit.addEventListener('click', function () { zpetNeboZavri(); });
    hlava.appendChild(pocitadlo);
    hlava.appendChild(zavrit);

    stopa = document.createElement('div');
    stopa.className = 'listovani-stopa';

    sipkaZpet = sipka('zpet', '‹', texty.predchozi, -1);
    sipkaVpred = sipka('vpred', '›', texty.dalsi, 1);

    var pata = document.createElement('div');
    pata.className = 'listovani-pata';
    var popis = document.createElement('div');
    popis.className = 'listovani-popis';
    nazevEl = document.createElement('b');

    // Příběh díla (2026-09-19 na přání majitelky: „máme obrazy s příběhem!").
    // Skrytý, dokud nedorazí seznam — první snímek se skládá z dlaždice,
    // kde příběh není, a prázdný odstavec by jen poskočil rozvržením.
    pribehEl = document.createElement('p');
    pribehEl.className = 'listovani-pribeh';
    pribehEl.hidden = true;

    // Rozbalení příběhu (2026-09-19 na přání majitelky: „ten popis obrazu by
    // se měl nějak rozkliknout, protože takhle to nepřečtu v mobilu").
    // Pata při rozbalení naroste nahoru přes obraz; druhé klepnutí ji srovná.
    vicEl = document.createElement('button');
    vicEl.type = 'button';
    vicEl.className = 'listovani-vic';
    vicEl.hidden = true;
    vicEl.addEventListener('click', function () {
      var otevrit = !pribehEl.classList.contains('je-rozbaleny');
      pribehEl.classList.toggle('je-rozbaleny', otevrit);
      vicEl.textContent = otevrit ? texty.min : texty.vic;
      vicEl.setAttribute('aria-expanded', otevrit ? 'true' : 'false');
    });

    cenaEl = document.createElement('span');
    popis.appendChild(nazevEl);
    popis.appendChild(pribehEl);
    popis.appendChild(vicEl);
    popis.appendChild(cenaEl);
    koupitEl = document.createElement('a');
    koupitEl.className = 'button listovani-koupit';
    koupitEl.textContent = texty.koupit;

    // Srdce stojí vlevo od nákupu: je to vedlejší krok („zatím se jen
    // rozhlížím"), tak ať nepřebíjí hlavní tlačítko. Kreslí se ručním SVG,
    // protože znak srdce vypadá v každém písmu jinak a v některých se z něj
    // stane barevné emoji.
    srdceEl = document.createElement('button');
    srdceEl.type = 'button';
    srdceEl.className = 'listovani-srdce';
    srdceEl.setAttribute('aria-pressed', 'false');
    srdceEl.setAttribute('aria-label', texty.oblibene);
    srdceEl.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 20.6 4.3 13a4.6 4.6 0 0 1 .2-6.8 4.6 4.6 0 0 1 6.3.4l1.2 1.3 1.2-1.3' +
      'a4.6 4.6 0 0 1 6.3-.4 4.6 4.6 0 0 1 .2 6.8z"/></svg>';
    srdceEl.addEventListener('click', function () {
      var s = sklad();
      var d = seznam[aktualni];
      if (!s || !d || !d.handle) return;
      s.prepni(d);
      nastavSrdce(d);
    });

    pata.appendChild(popis);
    pata.appendChild(srdceEl);
    pata.appendChild(koupitEl);

    vrstva.appendChild(hlava);
    vrstva.appendChild(stopa);
    vrstva.appendChild(sipkaZpet);
    vrstva.appendChild(sipkaVpred);
    vrstva.appendChild(pata);
    document.body.appendChild(vrstva);

    var cekam;
    stopa.addEventListener('scroll', function () {
      clearTimeout(cekam);
      cekam = setTimeout(zmerPolohu, 90);
    }, { passive: true });
  }

  function naplnSnimky(novy) {
    seznam = novy;
    aktualni = -1;
    stopa.innerHTML = '';
    seznam.forEach(function (d) {
      var snimek = document.createElement('div');
      snimek.className = 'listovani-snimek';
      var img = document.createElement('img');
      img.alt = d.nazev || '';
      img.decoding = 'async';
      if (d.hotovy) {
        // Obrázek z dlaždice se ukáže okamžitě (prohlížeč ho má stažený)
        // a na pozadí se dotáhne ostrá verze na celou obrazovku.
        img.src = d.hotovy;
        var velka = new Image();
        velka.onload = function () { img.src = velka.src; };
        velka.src = zvetsi(d.hotovy);
      } else {
        img.dataset.zdroj = d.obrazek;
      }
      snimek.appendChild(img);
      stopa.appendChild(snimek);
    });
  }

  /* ------------------------------------------------------------- pohyb */

  function zmerPolohu() {
    if (!otevreno || !stopa.clientWidth) return;
    var i = Math.round(stopa.scrollLeft / stopa.clientWidth);
    if (i !== aktualni) ukazPopis(i);
  }

  // Obrázky se nastavují jen kolem aktuálního snímku. Kolekce může mít přes
  // sto děl a stahovat je všechny by bylo nechutné.
  function dopraveObrazky(stred) {
    for (var i = stred - 1; i <= stred + 1; i++) {
      if (i < 0 || i >= seznam.length) continue;
      var img = stopa.children[i].firstChild;
      if (img && img.dataset.zdroj) {
        img.srcset = srcset(img.dataset.zdroj);
        img.sizes = '92vw';
        img.src = zvetsi(img.dataset.zdroj);
        delete img.dataset.zdroj;
      }
    }
  }

  /* ------------------------------------------------- oblíbená díla */

  // Ukládání se od 2026-09-19 nedělá tady, ale v assets/oblibene-sklad.js:
  // tutéž logiku potřebuje i výpis oblíbených a srdíčka v mřížce.
  // Sklad se načítá dřív (viz layout/theme.liquid); kdyby přesto chyběl,
  // srdce se prostě neukáže a zbytek prohlížečky běží dál.
  function sklad() {
    return window.GalelieOblibene || null;
  }

  function nastavSrdce(d) {
    if (!srdceEl) return;
    var s = sklad();
    var ulozene = !!(s && d && d.handle && s.jeUlozene(d.handle));
    srdceEl.setAttribute('aria-pressed', ulozene ? 'true' : 'false');
    srdceEl.setAttribute('aria-label', ulozene ? texty.oblibeneZrus : texty.oblibene);
  }

  function ukazPopis(i) {
    if (i < 0 || i >= seznam.length) return;
    aktualni = i;
    var d = seznam[i];
    nazevEl.textContent = d.nazev || '';
    cenaEl.textContent = d.cena || '';
    pribehEl.textContent = d.pribeh || '';
    pribehEl.hidden = !d.pribeh;

    // Každé dílo se otevírá zabalené — jinak by po přelistování zůstala pata
    // roztažená a zakrývala by další obraz.
    pribehEl.classList.remove('je-rozbaleny');
    vicEl.textContent = texty.vic;
    vicEl.setAttribute('aria-expanded', 'false');
    // Tlačítko má smysl jen tam, kde je text opravdu oříznutý. Měří se až
    // po vykreslení: `scrollHeight` zná skutečnou výšku textu teprve tehdy.
    vicEl.hidden = true;
    if (d.pribeh) {
      window.setTimeout(function () {
        vicEl.hidden = pribehEl.scrollHeight <= pribehEl.clientHeight + 1;
      }, 0);
    }
    koupitEl.href = d.url;
    nastavSrdce(d);
    // Dokud je v pásu jen klepnutý obraz, počitadlo by lhalo („1 / 1").
    pocitadlo.textContent = seznam.length > 1 ? (i + 1) + ' / ' + seznam.length : '';
    sipkaZpet.disabled = i === 0;
    sipkaVpred.disabled = i === seznam.length - 1;
    dopraveObrazky(i);
  }

  function jdiNa(i, plynule) {
    if (i < 0 || i >= seznam.length) return;
    dopraveObrazky(i);
    var puvodni = stopa.style.scrollBehavior;
    if (!plynule) stopa.style.scrollBehavior = 'auto';
    stopa.scrollLeft = i * stopa.clientWidth;
    if (!plynule) stopa.style.scrollBehavior = puvodni;
    ukazPopis(i);
  }

  /* ------------------------------------------------- otevření a zavření */

  function klavesa(e) {
    if (!otevreno) return;
    if (e.key === 'Escape') zpetNeboZavri();
    else if (e.key === 'ArrowRight') jdiNa(aktualni + 1, true);
    else if (e.key === 'ArrowLeft') jdiNa(aktualni - 1, true);
  }

  function otevri(i) {
    if (!otevreno) {
      vratitFokus = document.activeElement;
      otevreno = true;
      vrstva.hidden = false;
      document.documentElement.classList.add('listovani-zamek');
      vrstva.querySelector('.listovani-zavrit').focus();
      document.addEventListener('keydown', klavesa);
      // Tlačítko zpět (a gesto na telefonu) má vrstvu zavřít, ne odejít z webu.
      history.pushState({ galelieListovani: true }, '');
    }
    // Šířku snímku zná prohlížeč až po zobrazení, proto až teď.
    jdiNa(i, false);
  }

  function zavri() {
    if (!otevreno) return;
    otevreno = false;
    otevrenyHandle = null;
    vrstva.hidden = true;
    document.documentElement.classList.remove('listovani-zamek');
    document.removeEventListener('keydown', klavesa);
    if (vratitFokus && vratitFokus.focus) vratitFokus.focus();
  }

  function zpetNeboZavri() {
    if (history.state && history.state.galelieListovani) history.back();
    else zavri();
  }

  window.addEventListener('popstate', function () {
    if (otevreno) zavri();
  });

  /* ------------------------------------------------------------ klepnutí */

  mrizka.addEventListener('click', function (e) {
    var odkaz = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!odkaz || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();

    var prozatim = zDlazdice(odkaz);
    otevrenyHandle = prozatim.handle;
    if (!vrstva) vytvorVrstvu();

    if (dila) {
      naplnSnimky(dila);
      otevri(poradi(dila, prozatim.handle));
      return;
    }

    // Seznam ještě není — ukáže se aspoň klepnutý obraz, ať se něco děje.
    naplnSnimky([prozatim]);
    otevri(0);

    nacti().then(function (plny) {
      // Mezitím mohl návštěvník zavřít nebo klepnout na jiné dílo.
      if (!otevreno || otevrenyHandle !== prozatim.handle) return;
      naplnSnimky(plny);
      jdiNa(poradi(plny, prozatim.handle), false);
    }).catch(function () {
      // Když se seznam nepovede stáhnout, zůstane aspoň klepnutý obraz.
    });
  });
})();
